
<mat-card class="" [formGroup]="form">
  <mat-card-title>
    {{ 'CONTACT_PAGE.CONTACT_US_TITLE' | translate }}
  </mat-card-title>
  <mat-card-content>

    {{ 'CONTACT_PAGE.CONTACT_US_MESSAGE' | translate }}
    
    <mat-form-field color="primary" appearance="standard">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email">
    </mat-form-field>

    <mat-form-field color="primary" appearance="standard">
      <mat-label>Phone Number</mat-label>
      <input matInput formControlName="phoneNumber">
    </mat-form-field>

    <mat-form-field color="primary" appearance="standard">
      <mat-label>{{'CONTACT_PAGE.CONTACT_US_PLACEHOLDER' | translate }}</mat-label>
      <textarea matInput formControlName="message"></textarea>
    </mat-form-field>

<button mat-flat-button (click)="sendMessage()" color="primary" [disabled]="!form.valid">Send</button>

<div>
  {{ 'CONTACT_PAGE.CONTACT_US_MESSAGE_BY_EMAIL_PART1' | translate }}
    <a
      href="{{getEmailAnchor()}}">{{ 'CONTACT_PAGE.CONTACT_US_MESSAGE_BY_EMAIL_TEXT' | translate }}
    </a>
    {{ 'CONTACT_PAGE.CONTACT_US_MESSAGE_BY_EMAIL_PART2' | translate }}
    <a class="phone-link"
       href="{{getPhoneAnchor()}}">{{ 'CONTACT_PAGE.CONTACT_US_MESSAGE_BY_EMAIL_PHONE_PART' | translate }}</a><span>.</span>

</div>

  </mat-card-content>
</mat-card>
